import { createContext } from "react";
import { AccountData } from "../Models/AccountModel";

interface AccountContext {
    accountData: AccountData;
    setAccountData: React.Dispatch<React.SetStateAction<AccountData>>;
}
export const AccountContext = createContext<AccountContext>({accountData: {} as AccountData, setAccountData: () => {}});